import { render, staticRenderFns } from "./my-agent.vue?vue&type=template&id=9979bdb4&scoped=true"
import script from "./my-agent.vue?vue&type=script&lang=js"
export * from "./my-agent.vue?vue&type=script&lang=js"
import style0 from "./my-agent.vue?vue&type=style&index=0&id=9979bdb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9979bdb4",
  null
  
)

export default component.exports